import React from 'react';
export const FormRow = ({ label, hidden = false, children }) => (<div className={`account-settings-field form-field ${hidden && 'hidden'}`}>
    <div className="account-settings-field__data">
      <span className="account-settings-field__label account-settings-field__box">
        {label}
      </span>
      <div className="account-settings-field__input-wrapper account-settings-field__box" style={{ maxWidth: 'unset' }}>
        {children}
      </div>
    </div>
  </div>);
